'use client'

import { usePageExitBeacon } from '@/hooks/usePageExitBeacon'

/**
 * Monta o aviso de saída da aba no grupo de rotas autenticado.
 *
 * O aviso é do cliente: o `accessedPagesMiddleware` roda no servidor do Next e
 * não tem como ver o navegador fechar. E fica aqui, e não no `Header`, por dois
 * motivos: o `Header` é um componente de apresentação com storybook e teste
 * próprios, onde um listener global de `window` passaria a rodar sem motivo; e
 * este layout já é o lugar onde o projeto pendura efeito de sessão
 * (`InactivityWatcher`, `PageTracker`).
 *
 * Estar em `(app)` já garante que nada é montado em `login`, convite ou
 * recuperação de senha, que vivem em `(login)`. A checagem de página pública
 * dentro do hook é a segunda trava, para o dia em que o layout mudar.
 */
export function PageExitBeacon() {
  usePageExitBeacon()

  return null
}
